import { Space } from 'antd';
import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { Checkbox } from 'components/atoms/checkbox';
import {
  FormItemWrapper,
  FormItemDesc,
  FormItemLabel,
  FieldsErrorRenderer,
  FormFieldProps,
} from './form-elements';

const CheckboxGroup = styled(Checkbox.Group)`
  margin-top: var(--spacing-03);
`;
const CheckBoxItem = styled(Checkbox)`
  display: flex;
  height: auto;
  .ant-checkbox {
    margin-top: var(--spacing-01);
  }
`;

export const CheckboxChoiceField: FC<FormFieldProps> = ({
  field,
  control,
  setValue,
  errors,
  disabled,
}) => {
  return (
    <FormItemWrapper>
      <FormItemLabel label={field.questionText} required={field.required} />
      <FormItemDesc label={field.description} />
      <Controller
        control={control}
        rules={{ required: field.required }}
        name={field.questionId.toString()}
        shouldUnregister
        render={(props) => (
          <CheckboxGroup
            disabled={disabled}
            value={props.field.value}
            onChange={(values) =>
              setValue?.(
                field.questionId.toString(),
                values && values.length ? values : undefined,
              )
            }
          >
            <Space direction="vertical">
              {field.options?.map((option) => {
                return (
                  <CheckBoxItem value={option.optionId} ref={props.field.ref}>
                    {option.optionLabel}
                  </CheckBoxItem>
                );
              })}
            </Space>
          </CheckboxGroup>
        )}
      />

      <FieldsErrorRenderer errors={errors} questionId={field.questionId} />
    </FormItemWrapper>
  );
};
